import urljoin from 'url-join';
import { discoveryApi } from './index.api';

export const projectsApi = discoveryApi.injectEndpoints({
	endpoints: (builder) => ({
		projects: builder.query({
			query: (projectIds) => ({
				// baseQueryWithAuth handles authorization header automatically
				url: urljoin('client', 'projects'),
				method: 'POST',
				body: projectIds
			}),
			providesTags: ['discovery']
		}),
	})
});

export const {
	useProjectsQuery,
} = projectsApi;
